import { SettingsLogoutConfigurationService } from 'capability-ng-settings';
import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { StringUtility } from 'utility-ts-type';
import { PriorityFeedCapabilityConfiguration } from '../../configuration';

declare const RenderTypeEnum: any;
export class AccountAvatarController {
  private initial: string;
  private isAccountMenuOpen: boolean = false;
  private isMobile: boolean;

  constructor(
    private $state: ng.ui.IStateService,
    private $scope: ng.IScope,
    private accountModel: AccountModel,
    private loginConfigModel: any,
    private ngSettingsLogoutConfigurationService: SettingsLogoutConfigurationService,
    private logoutCommand: ICommand,
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration
  ) {
    this.isMobile = this.ngPriorityFeedCapabilityConfiguration.config.isMobile;
    this.getInitial();

    $scope.avatarMenuGid = 'avatar-menu-' + _4.uniqueId();
    $scope.avatarButtonGid = 'avatar-button-' + _4.uniqueId();
  }

  getInitial() {
    this.initial = StringUtility.getAcronym(...this.accountModel.fullname.split(' '));
  }

  resetAccountMenu() {
    this.isAccountMenuOpen = false;
  }

  toggleAccountMenu() {
    this.isAccountMenuOpen = !this.isAccountMenuOpen;
  }

  goToAccount() {
    this.resetAccountMenu();
    this.$state.go('my.settings');
  }

  goToFavorite() {
    this.resetAccountMenu();
    this.$state.go('my.favorites');
  }

  goToSitemap() {
    this.resetAccountMenu();
    location.href = '#/sitemap';
  }

  logout() {
    if (this.isMobile) {
      if (RenderTypeEnum.isButtonOnlyLogin(this.loginConfigModel.render_type)) {
        this.$state.go('account-login-cas-auth');
      } else if (RenderTypeEnum.isUserPassLogin(this.loginConfigModel.render_type)) {
        this.$state.go('account-login-ldap-auth');
      } else {
        this.ngSettingsLogoutConfigurationService.invokeLogout('institution-landing');
      }
    } else {
      this.logoutCommand();
    }
  }
}
export class AccountAvatarComponent implements ng.IComponentOptions {
  public controller: object = AccountAvatarController;
  public templateUrl: string = 'capability-ng-priority-feed/src/components/account_avatar/account_avatar.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/account_avatar/account_avatar.ts